
///* TODO: Componente incesario, se puede usar emptyCell(<value>, '—')

export const renderEmpty = (value: any) => (
  value
    ? value
    : <span
      style={{
        display: 'inline-block',
        width: '30px',
        borderBottom: '2px solid #000',
        verticalAlign: 'middle'
      }}
    />
);
